
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";
import Navigation from "../components/Navigation";
import FortuneBackground from "../components/FortuneBackground";
import RecipeHeader from "../components/recipe/RecipeHeader";
import RecipeIntro from "../components/recipe/RecipeIntro";
import RecipeOverview from "../components/recipe/RecipeOverview";
import RecipeIngredients from "../components/recipe/RecipeIngredients";
import RecipeInstructions from "../components/recipe/RecipeInstructions";
import RecipeTroubleshooting from "../components/recipe/RecipeTroubleshooting";
import RecipeVariations from "../components/recipe/RecipeVariations";
import RecipeCultural from "../components/recipe/RecipeCultural";
import RecipeActions from "../components/recipe/RecipeActions";

const Recipe = () => {
  return (
    <>
      <Helmet>
        <title>Homemade Fortune Cookie Recipe | Perfect Authentic Fortune Cookies</title>
        <meta name="description" content="Learn how to make perfect homemade fortune cookies with our authentic recipe. Create your own personalized fortunes for special occasions or everyday fun." />
        <meta name="keywords" content="fortune cookie recipe, cook fortune cookie at home, make fortune cookie at home, homemade fortune cookies, authentic fortune cookie recipe" />
        <meta property="og:title" content="Homemade Fortune Cookie Recipe | Perfect Authentic Fortune Cookies" />
        <meta property="og:description" content="Our tested fortune cookie recipe creates the perfect crispy, golden cookies with custom fortunes - just like the ones from restaurants but better!" />
        <meta property="og:type" content="article" />
        <meta property="og:url" content="/recipe" />
        <meta property="og:image" content="/fortune-cookie-og.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Homemade Fortune Cookie Recipe | Perfect Authentic Fortune Cookies" />
        <meta name="twitter:description" content="Our tested fortune cookie recipe creates the perfect crispy, golden cookies with custom fortunes - just like the ones from restaurants but better!" />
        <meta name="twitter:image" content="/fortune-cookie-og.png" />
        <link rel="canonical" href="/recipe" />
      </Helmet>

      <div className="min-h-screen flex flex-col p-8 pb-40 relative overflow-hidden">
        <FortuneBackground />

        <div className="max-w-4xl mx-auto w-full">
          <div className="mb-8">
            <Link to="/">
              <Button variant="ghost" className="flex items-center gap-2 text-muted-foreground hover:text-foreground">
                <ArrowLeft size={16} />
                Back to Fortune
              </Button>
            </Link>
          </div>

          <Navigation />

          <div className="max-w-4xl mx-auto w-full mb-16">
            <motion.div 
              className="space-y-12"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <RecipeHeader />

              <motion.section 
                className="prose prose-slate max-w-none"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.6, duration: 0.8 }}
              >
                <RecipeIntro />
                <RecipeOverview />
                <RecipeIngredients />
                <RecipeInstructions />
                <RecipeTroubleshooting />
                <RecipeVariations />
                <RecipeCultural />
              </motion.section>

              <RecipeActions />
            </motion.div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Recipe;
